import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InformationService {
  constructor(private httpService: HttpService) { }

  getInformations(params: any): Observable<any> {
    return this.httpService.get('information', { params });
  }

  getInformation(id: number): Observable<any> {
    return this.httpService.get(`information/${id}`);
  }

  createOrUpdateInformation(payload: any): Observable<any> {
    return this.httpService.post(`information`, payload);
  }

  deleteInformation(id: number): Observable<any> {
    return this.httpService.delete(`information/${id}`);
  }
}